module.exports = __webpack_public_path__ + "img/mobile-analytics.c0214402.png";